const MapUtils = {}

MapUtils.placeInCurrentView = ({ map, place, }) => {
  let inCurrentView = true
  const mapBounds = {
    top: map.getBounds().getNorthEast().lat(),
    right: map.getBounds().getNorthEast().lng(),
    bottom: map.getBounds().getSouthWest().lat(),
    left: map.getBounds().getSouthWest().lng(),
  }
  const placeLatLng = {
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng(),
  }
  // check longitude (vertical)
  if (placeLatLng.lng > mapBounds.right || placeLatLng.lng < mapBounds.left) {
    inCurrentView = false
  }
  // check latitiude (horizontal)
  if (placeLatLng.lat > mapBounds.top || placeLatLng.lat < mapBounds.bottom) {
    inCurrentView = false
  }
  return inCurrentView
}

MapUtils.zoomOut = ({ map, }) => {
  const newZoom = map.minZoom || 1
  map.setZoom(newZoom)
}

MapUtils.centerPointOfMarkers = ({ markers, }) => {
  const minMax = {
    minLat: null,
    maxLat: null,
    minLng: null,
    maxLng: null,
  }
  markers.forEach((marker) => {
    minMax.minLat = !minMax.minLat || marker.lat < minMax.minLat ? marker.lat : minMax.minLat
    minMax.maxLat = !minMax.maxLat || marker.lat > minMax.maxLat ? marker.lat : minMax.maxLat
    minMax.minLng = !minMax.minLng || marker.lng < minMax.minLng ? marker.lng : minMax.minLng
    minMax.maxLng = !minMax.maxLng || marker.lng > minMax.maxLng ? marker.lng : minMax.maxLng
  })
  const centerPoint = {
    lat: (minMax.minLat + minMax.maxLat) / 2,
    lng: (minMax.minLng + minMax.maxLng) / 2,
  }
  // centerPoint = { lat: -12.21517, lng: -22.44061, }
  return centerPoint
}

MapUtils.panTo = ({ google, map, lat, lng, }) => {
  const target = new google.maps.LatLng(lat, lng)
  map.panTo(target)
}

MapUtils.slowPanTo = ({ google, map, lat, lng, }) => {
  const startPosition = map.getCenter()
  const lat_delta = lat - startPosition.lat()
  const lng_delta = lng - startPosition.lng()
  const maxDelta = Math.abs(lat_delta) > Math.abs(lng_delta)
    ? Math.abs(lat_delta)
    : Math.abs(lng_delta)
  let intervals = 40
  const msec = 100
  // set intervals based on zoom level and max delta
  // zoom 2, 40 @ 100
  // zoom 3, 40 @ 100
  // zoom 4, 30 @ 100 && [+60 delta] 20 @ 100
  // zoom 5 +, 10 @ 100
  const currentZoom = map.getZoom()
  if (currentZoom === 4) {
    intervals = 30
    if (maxDelta > 60) {
      intervals = 20
    }
  } else if (currentZoom > 4) {
    intervals = 10
  }

  const getStep = delta => parseFloat(delta) / intervals
  const lat_step = getStep(lat_delta)
  const lng_step = getStep(lng_delta)
  const lat_array = []
  const lng_array = []
  let i
  let j
  let ref

  for (i = j = 1, ref = intervals; j <= ref; i = j += +1) {
    lat_array.push(map.getCenter().lat() + i * lat_step)
    lng_array.push(map.getCenter().lng() + i * lng_step)
  }
  const f_timeout = () => parseFloat(msec) / intervals
  const pan = (p) => {
    if (p < lat_array.length) {
      return setTimeout(() => {
        map.panTo(
          new google.maps.LatLng({
            lat: lat_array[p],
            lng: lng_array[p],
          })
        )
        return pan(p + 1)
      }, f_timeout(p, 0, lat_array.length - 1))
    }
    return null
  }
  return pan(0)
}

MapUtils.zoomOutAndCenter = ({ map, markers, }) => {
  MapUtils.zoomOut({ map, })
  map.panTo(MapUtils.centerPointOfMarkers({ markers, }))
}

export default MapUtils



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/lib/MapUtils.js